export type Plant = {
	id: string;
	name: string;
	species: string;
	location: string;
	soilMoisture: number;
	lastWateredAt: string;
	health: 'good' | 'fair' | 'poor';
};

export const plants: Plant[] = [
	{ id: 'p1', name: 'Aloe Vera', species: 'Aloe barbadensis', location: 'Window Sill', soilMoisture: 35, lastWateredAt: new Date(Date.now() - 86400000 * 3).toISOString(), health: 'good' },
	{ id: 'p2', name: 'Snake Plant', species: 'Sansevieria', location: 'Living Room', soilMoisture: 42, lastWateredAt: new Date(Date.now() - 86400000 * 7).toISOString(), health: 'good' },
	{ id: 'p3', name: 'Peace Lily', species: 'Spathiphyllum', location: 'Office', soilMoisture: 58, lastWateredAt: new Date(Date.now() - 86400000 * 1).toISOString(), health: 'fair' },
	{ id: 'p4', name: 'Monstera', species: 'Monstera deliciosa', location: 'Dining Room', soilMoisture: 47, lastWateredAt: new Date(Date.now() - 86400000 * 4).toISOString(), health: 'good' },
	{ id: 'p5', name: 'Basil', species: 'Ocimum basilicum', location: 'Kitchen', soilMoisture: 63, lastWateredAt: new Date(Date.now() - 86400000 * 2).toISOString(), health: 'fair' }
];


